import { getMethodWithToken } from 'services/apiServices';
import url from 'services/urls.json';
import { ClearTokenRedirectLogin } from 'utils/general';

// Action Types
export const GET_DISCOUNT_TYPE = 'GET_DISCOUNT_TYPE';
export const GET_DISCOUNT_TYPE_SUCCESS = 'GET_DISCOUNT_TYPE_SUCCESS';
export const GET_DISCOUNT_TYPE_FAILURE = 'GET_DISCOUNT_TYPE_FAILURE';

// Action Creators
export const fetchGetDiscountType = () => ({
  type: GET_DISCOUNT_TYPE,
});

export const fetchGetDiscountTypeSuccess = (data) => ({
  type: GET_DISCOUNT_TYPE_SUCCESS,
  payload: data,
});

export const fetchGetDiscountTypeFailure = (error) => ({
  type: GET_DISCOUNT_TYPE_FAILURE,
  payload: error,
});

// Thunk Function
export const getDiscountTypeCallAPI = (data, external = {}) => {
  return async (dispatch) => {
    dispatch(fetchGetDiscountType(data, external));
    try {
      const response = await getMethodWithToken(
        url.getDiscountTypeListSuperAdmin
      );
      if (response.status === 200 || response.status === 201) {
        dispatch(fetchGetDiscountTypeSuccess(response.data));

        if (external && external.redirect === true) {
          external.redirectNavigate(external.path);
        } else if (external && external.run === true) {
          external.handleFunction(response);
        } else if (external && external.step) {
          external.handleStep(external.step);
        }
      } else if (response.status === 401) {
        ClearTokenRedirectLogin(external?.navigate);
      } else {
        dispatch(fetchGetDiscountTypeFailure('Error'));
        if (external && external.toast) {
          external.handleToastError(response);
        }
      }
    } catch (error) {
      dispatch(fetchGetDiscountTypeFailure(error.message));
    }
  };
};
